const question3 = {
    'question': 'Jak długi okres czasu może trwać terapia rodzinna?',
    'answer': 'Terapia rodzinna trwa od kilku do kilkunastu miesięcy. W przypadku stosunkowo prostych problemów terapia może zakończyć się nawet po kilku spotkaniach. W przypadku bardziej złożonych problemów terapia może trwać nawet kilka lat.',
}

export default question3;